import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownRendererProps {
  markdown: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ markdown }) => (
  <Markdown remarkPlugins={[remarkGfm]}>{markdown}</Markdown>
);

export default MarkdownRenderer;
